var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhoneLockDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 14.619C11.25 10.4112 14.8317 7 19.25 7H35.25C39.6683 7 43.25 10.4112 43.25 14.619V47H11.25V14.619Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.25 8.90476H19.25C15.9363 8.90476 13.25 11.4631 13.25 14.619V47H41.25V14.619C41.25 11.4631 38.5637 8.90476 35.25 8.90476ZM19.25 7C14.8317 7 11.25 10.4112 11.25 14.619V47H43.25V14.619C43.25 10.4112 39.6683 7 35.25 7H19.25Z",
    fill: "#DEDEDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 9H33.25V10C33.25 11.1046 32.3546 12 31.25 12H23.25C22.1454 12 21.25 11.1046 21.25 10V9Z",
    fill: "#DEDEDE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13565_8746)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1847 16.9849C30.4705 16.446 33.8315 16.167 37.2503 16.167C40.6689 16.167 44.0296 16.4459 47.3151 16.9847C50.0995 17.4413 52.0277 20.1613 52.0277 23.2163V32.6647C52.0277 35.7197 50.0995 38.4397 47.3151 38.8963C44.5858 39.3438 41.8045 39.6121 38.9813 39.6901C38.8355 39.6941 38.7021 39.7592 38.6064 39.866L32.7186 43.3777C32.4167 43.7144 31.9627 43.8151 31.5682 43.6329C31.1738 43.4507 30.9166 43.0214 30.9166 42.5452V39.3921C29.6626 39.2641 28.4183 39.0984 27.1847 38.8961C24.4004 38.4394 22.4722 35.7195 22.4722 32.6646V23.2164C22.4722 20.1614 24.4004 17.4415 27.1847 16.9849Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8471 20.9473C39.3838 20.9473 40.6295 22.193 40.6295 23.7297V25.1208H42.3685C42.9448 25.1208 43.4119 25.588 43.4119 26.1642V33.8158C43.4119 34.3921 42.9448 34.8592 42.3685 34.8592H33.3257C32.7495 34.8592 32.2823 34.3921 32.2823 33.8158V26.1642C32.2823 25.588 32.7495 25.1208 33.3257 25.1208H35.0647V23.7297C35.0647 22.193 36.3105 20.9473 37.8471 20.9473ZM37.8472 28.9466C37.271 28.9466 36.8038 29.4138 36.8038 29.99C36.8038 30.5663 37.271 31.0334 37.8472 31.0334C38.4235 31.0334 38.8906 30.5663 38.8906 29.99C38.8906 29.4138 38.4235 28.9466 37.8472 28.9466ZM37.8471 22.3385C37.0788 22.3385 36.4559 22.9613 36.4559 23.7297V25.1208H39.2383V23.7297C39.2383 22.9613 38.6155 22.3385 37.8471 22.3385Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13565_8746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 28,
    fill: "white",
    transform: "translate(22.25 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoneLockDisabled);
export default __webpack_public_path__ + "static/media/icon-phone-lock-disabled.7e3638a994273df164531d833c21bd36.svg";
export { ForwardRef as ReactComponent };